module.exports = __webpack_public_path__ + "static/media/villano256.39431387.png";